import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Tooltip } from "react-tooltip";
interface StormButtonProps {
  readonly isStormMode: boolean;
  readonly canAddPart: boolean;
  readonly submitting: boolean;
  readonly breakIntoStorm: () => void;
}
const StormButton: React.FC<StormButtonProps> = t0 => {
  const $ = _c(14);
  const {
    isStormMode,
    canAddPart,
    submitting,
    breakIntoStorm
  } = t0;
  const t1 = !canAddPart || submitting;
  const t2 = `tw-flex tw-items-center tw-justify-center tw-flex-shrink-0  tw-rounded-full tw-transition tw-duration-300 tw-size-8 lg:tw-size-7 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-iron-500 tw-border-0 ${canAddPart && !submitting ? "tw-cursor-pointer tw-text-iron-300 desktop-hover:hover:tw-text-primary-400 desktop-hover:hover:tw-bg-primary-300/20 tw-bg-iron-700" : "tw-cursor-default tw-text-iron-600 desktop-hover:hover:tw-text-iron-600 tw-bg-iron-900"}`;
  const t3 = `tw-h-[1.1rem] tw-w-[1.1rem] lg:tw-size-4 tw-flex-shrink-0 ${!canAddPart || submitting ? "tw-opacity-50" : ""}`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d="M21 4H3M20 8L6 8M18 12L9 12M15 16L8 16M17 20H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== t3) {
    t5 = <svg className={t3} viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t4}</svg>;
    $[1] = t3;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== breakIntoStorm || $[4] !== t1 || $[5] !== t2 || $[6] !== t5) {
    t6 = <button onClick={breakIntoStorm} disabled={t1} type="button" className={t2} data-tooltip-id="storm-button-tooltip">{t5}</button>;
    $[3] = breakIntoStorm;
    $[4] = t1;
    $[5] = t2;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = isStormMode ? "Add a part" : "Break into storm";
  let t9;
  if ($[9] !== t8) {
    t9 = <Tooltip id="storm-button-tooltip" place="top" positionStrategy="fixed" style={t7}><span className="tw-text-xs">{t8}</span></Tooltip>;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t6 || $[12] !== t9) {
    t10 = <div>{t6}{t9}</div>;
    $[11] = t6;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
};
export default StormButton;